import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CommunicationService {
  private countryChangedSubject = new BehaviorSubject<string | null>(null);
  private provinceChangedSubject = new BehaviorSubject<string | null>(null);
  private provincesSubject = new BehaviorSubject<any[]>([]);
  private municipalitiesSubject = new BehaviorSubject<any[]>([]);

  countryChanged$ = this.countryChangedSubject.asObservable();
  provinceChanged$ = this.provinceChangedSubject.asObservable();
  provinces$ = this.provincesSubject.asObservable();
  municipalities$ = this.municipalitiesSubject.asObservable();

  emitCountryChanged(country: string) {
    this.countryChangedSubject.next(country);
  }

  emitProvinceChanged(province: string) {
    console.log('emitChanged', this.provinceChangedSubject.next(province));
    this.provinceChangedSubject.next(province);
  }

  updateProvinces(provinces: any[]) {
    this.provincesSubject.next(provinces);
  }

  updateMunicipalities(municipalities: any[]) {
    this.municipalitiesSubject.next(municipalities);
  }
}
